import { baseConfig } from '../base.config';
import { mix } from '@oec-seller/sdk/m4b-seller-material';
export const REGION_CONFIG = mix(baseConfig, {
  features: {
    showRegionItem: true,
    defaultRegion: 'GB',
    privacyPolicyLink: ''
  },
  language: {
    switchLang: [
      'en',
      'id-ID',
      'vi-VN',
      'th-TH',
      'ms-MY',
      'es',
      'de-DE',
      'it-IT',
      'fr',
      'es-419',
      'zh-CN',
      'nl-NL',
      'pl-PL'
    ],
    defaultLang: 'en'
  }
} as Partial<typeof baseConfig>);
